export default __webpack_public_path__ + "static/media/milestone 4000.5bcf444e.svg";